/* Resolve chosen options synchronously, before following the ordinary new-tab link. */
(() => {
  if (customElements.get('shop-label-access')) return;
  customElements.define('shop-label-access', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.link = this.querySelector('a');
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.initialHref = this.link.href;
      const update = event => {
        const root = this.dataset.brand === 'fa' ? document.getElementById('pfc-' + this.dataset.sectionId) : document.querySelector('.section-main-product');
        const selected = [];
        if (root) {
          root.querySelectorAll('.pfc-variant-select[data-option-index]').forEach(el => selected[Number(el.dataset.optionIndex)-1] = el.value);
          root.querySelectorAll('fieldset[data-option-index]').forEach(el => { const checked = el.querySelector('input:checked'); if (checked) selected[Number(el.dataset.optionIndex)-1] = checked.value; });
          const picker = root.querySelector('variant-picker.variant-picker__wrapper');
          picker?.querySelectorAll('.variant-option.selected[data-option-position]').forEach(el => selected[Number(el.dataset.optionPosition)-1] = el.dataset.value);
        }
        let variant;
        if (selected.length) variant = this.variants.find(v => v.options.every((value,index) => selected[index] === value));
        else {
          const id = root?.querySelector('input[name="id"][id^="pfc-variant-id-"]')?.value || root?.querySelector('variant-picker')?.dataset.currentVariantId || new URL(this.initialHref).searchParams.get('variant');
          variant = this.variants.find(v => String(v.id) === String(id));
        }
        this.querySelector('[role="status"]').textContent = variant ? '' : 'Изберете съществуващ вариант преди печат.';
        if (!variant) { event?.preventDefault(); this.link.setAttribute('aria-disabled','true'); return; }
        this.link.removeAttribute('aria-disabled');
        const url = new URL(this.initialHref); url.searchParams.set('variant', variant.id);
        // Keep the preview theme only when viewing a preview; printed QR never uses this URL.
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        this.link.href = url.href;
      };
      this.link.addEventListener('click', update);
      this.link.addEventListener('auxclick', update);
      this.link.addEventListener('contextmenu', update);
      this.link.addEventListener('focus', update);
    }
  });
})();
